// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  height: 100vh;
  --background: transparent;
  --overflow: hidden;
}

.container {
  height: 100%;
}
.container .top-row {
  margin-top: 0.333rem;
  margin-bottom: 0.333rem;
}
.container .top-row .title {
  font-size: 1rem;
  line-height: 1.375rem;
  color: var(--color-primary-blue);
}
.container .top-row .title-bold {
  font-weight: bold;
}
.container .main-content .main-content-col {
  display: flex;
  justify-content: center;
}
.container .main-content .main-content-col .box {
  width: 36rem;
  padding: 1rem 1.375rem;
  text-align: center;
  color: white;
  height: 13.962rem;
  position: relative;
  border-radius: 11px;
  background: white;
  box-shadow: rgba(0, 0, 0, 0.16) 2px 3px 0 1px, rgb(209, 213, 219) 0 0 0 1px inset;
}
.container .main-content .main-content-col .box:before {
  content: "";
  position: absolute;
  border-left: 2px solid var(--color-white);
  border-bottom: 2px solid var(--color-white);
  transform: rotateZ(45deg);
  width: 1rem;
  height: 1rem;
  background: var(--color-white);
  border-top: 0;
  border-right: 0;
  left: 17rem;
  bottom: -0.542rem;
}
.container .main-content .main-content-col .box .main-title {
  color: var(--color-primary-blue);
  letter-spacing: 0;
  line-height: 1.333rem;
  font-size: 1.167rem;
  font-weight: bold;
  margin-bottom: 1.125rem;
}
.container .main-content .main-content-col .box .subtitle1 {
  color: var(--color-primary-blue);
  letter-spacing: 0;
  line-height: 1.333rem;
  font-size: 1rem;
  font-weight: 600;
}
.container .main-content .main-content-col .box .page2 .main-title {
  color: #404953;
  font-size: 1rem;
  line-height: 1.333rem;
  font-weight: 600;
}
.container .main-content .main-content-col .box .page2 .bullets-box {
  display: inline-block;
}
.container .main-content .main-content-col .box .page2 .info .dimension-number {
  background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  font-size: 0.833rem;
  padding: 0.18rem 0.35rem;
  border-radius: 50%;
  color: var(--color-primary-blue);
  height: fit-content;
}
.container .main-content .main-content-col .box .page2 .info {
  display: flex;
  margin-bottom: 0.3rem;
}
.container .main-content .main-content-col .box .page2 .info .text {
  color: var(--color-primary-blue);
  font-size: 1rem;
  line-height: 1.333rem;
  font-weight: bold;
  margin-left: 0.5rem;
  text-align: initial;
}
.container .main-content .main-content-col .box .page2 .description-text {
  color: #404953;
  font-weight: 300;
  font-size: 1rem;
  text-align: start;
  margin-bottom: 0.667rem;
  min-height: 1.833rem;
}
.container .main-content .main-content-col .box .page2 .rectangle {
  min-height: 3.333rem;
  border-radius: 0.292rem;
  background-color: #F5DB6C;
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);
}
.container .main-content .main-content-col .box .page2 .rectangle .rectangle-text {
  color: var(--color-primary-blue);
  font-weight: 300;
  font-size: 1rem;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 0;
  text-align: center;
  margin-top: -0.2rem;
  padding: 0.4rem;
}
.container .main-content .main-content-col .box .page3 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.container .main-content .main-content-col .box .page3 .main-title {
  color: #404953;
  font-size: 0.833rem;
  line-height: 1.333rem;
  font-weight: 600;
}
.container .main-content .main-content-col .box .page3 .info .dimension-number {
  background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  font-size: 0.833rem;
  padding: 0.18rem 0.35rem;
  border-radius: 50%;
  color: var(--color-primary-blue);
  position: absolute;
  left: 1rem;
}
.container .main-content .main-content-col .box .page3 .info {
  display: flex;
  margin-bottom: 0.583rem;
}
.container .main-content .main-content-col .box .page3 .info .text {
  color: var(--color-primary-blue);
  font-size: 1rem;
  line-height: 1.333rem;
  font-weight: bold;
}
.container .main-content .main-content-col .box .page3 .propose-title {
  color: #273B5A;
  font-weight: 600;
  font-size: 1rem;
  text-align: start;
  margin-bottom: 0.458rem;
}
.container .main-content .main-content-col .box .page3 .description-text {
  color: #404953;
  font-weight: 300;
  font-size: 1rem;
  text-align: start;
  margin-bottom: 0.667rem;
  min-height: 1.833rem;
}
.container .main-content .main-content-col .box .page3 .rectangle {
  min-height: 3.333rem;
  border-radius: 0.292rem;
  background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);
}
.container .main-content .main-content-col .box .page3 .rectangle .rectangle-text {
  color: var(--color-primary-blue);
  font-weight: 300;
  font-size: 1rem;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.4rem;
}
.container .button-row {
  width: 36rem;
  margin: 0 auto;
}
.container .button-row .button-left-col {
  z-index: 2;
  text-align: start;
}
.container .button-row .button-left-col .previous-btn .button {
  font-size: 0.875rem;
  min-width: 8.417rem;
  height: 2rem;
  min-height: 2rem;
  --min-height: 2rem;
  font-weight: 600;
}
.container .button-row .button-right-col {
  z-index: 2;
  text-align: end;
}
.container .button-row .button-right-col .next-btn .button {
  font-size: 0.875rem;
  min-width: 8.417rem;
  height: 2rem;
  min-height: 2rem;
  --min-height: 2rem;
  font-weight: 600;
}
.container .presentation-col {
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
}
.container .presentation-col .presentation {
  height: 12.4rem;
  width: 6rem;
  display: flex;
  justify-content: center;
}
.container .presentation-col .presentation .group {
  position: absolute;
  top: 57%;
  z-index: 1;
  width: 4rem;
}
.container .presentation-col .presentation .tribune {
  position: absolute;
  width: 6rem;
  bottom: 0;
}
.container .presentation-col .presentation .avatar {
  position: absolute;
  width: 6rem;
}

.divScrollBar {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  max-height: 11.962rem;
  overflow-y: auto;
  width: 100%;
  height: 100%;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  padding-bottom: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/game/presentation-proposal/proposal/proposal.page.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;AACF;AACE;EACE,oBAAA;EACA,uBAAA;AACJ;AACI;EACE,eAAA;EACA,qBAAA;EACA,gCAAA;AACN;AAEI;EACE,iBAAA;AAAN;AAKI;EACE,aAAA;EACA,uBAAA;AAHN;AAKM;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iFAAA;AAHR;AAKQ;EACE,WAAA;EACA,kBAAA;EACA,yCAAA;EACA,2CAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;AAHV;AAMQ;EACE,gCAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;AAJV;AAOQ;EACE,gCAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AALV;AAgBU;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;AAdZ;AAiBU;EACE,qBAAA;AAfZ;AAmBY;EACE,yHAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;AAjBd;AAqBU;EACE,aAAA;EACA,qBAAA;AAnBZ;AAqBY;EACE,gCAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AAnBd;AAuBU;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,oBAAA;AArBZ;AAwBU;EACE,oBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yCAAA;AAtBZ;AAwBY;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AAtBd;AA2BQ;EACE,iBAAA;EACA,kBAAA;AAzBV;AA2BU;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AAzBZ;AA6BY;EACE,yHAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,UAAA;AA3Bd;AA+BU;EACE,aAAA;EACA,uBAAA;AA7BZ;AA+BY;EACE,gCAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;AA7Bd;AAiCU;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AA/BZ;AAkCU;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,oBAAA;AAhCZ;AAmCU;EACE,oBAAA;EACA,uBAAA;EACA,yHAAA;EACA,yCAAA;AAjCZ;AAmCY;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAjCd;AAyCE;EACE,YAAA;EACA,cAAA;AAvCJ;AAyCI;EACE,UAAA;EACA,iBAAA;AAvCN;AA0CQ;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAxCV;AA6CI;EACE,UAAA;EACA,eAAA;AA3CN;AA8CQ;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AA5CV;AAkDE;EACE,kBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;AAhDJ;AAkDI;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AAhDN;AAkDM;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;AAhDR;AAmDM;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAjDR;AAoDM;EACE,kBAAA;EACA,WAAA;AAlDR;;AAwDA;EACE,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,oBAAA;EACA,oBAAA;AArDF","sourcesContent":["ion-content {\n  height: 100vh;\n  --background: transparent;\n  --overflow: hidden;\n}\n\n.container {\n  height: 100%;\n\n  .top-row {\n    margin-top: 0.333rem;\n    margin-bottom: 0.333rem;\n\n    .title {\n      font-size: 1rem;\n      line-height: 1.375rem;\n      color: var(--color-primary-blue);\n    }\n\n    .title-bold {\n      font-weight: bold;\n    }\n  }\n\n  .main-content {\n    .main-content-col {\n      display: flex;\n      justify-content: center;\n\n      .box {\n        width: 36rem;\n        padding: 1rem 1.375rem;\n        text-align: center;\n        color: #ffff;\n        height: 13.962rem;\n        position: relative;\n        border-radius: 11px;\n        background: #ffff;\n        box-shadow: rgba(0, 0, 0, 16%) 2px 3px 0 1px, rgb(209, 213, 219) 0 0 0 1px inset;\n\n        &:before {\n          content: \"\";\n          position: absolute;\n          border-left: 2px solid var(--color-white);\n          border-bottom: 2px solid var(--color-white);\n          transform: rotateZ(45deg);\n          width: 1rem;\n          height: 1rem;\n          background: var(--color-white);\n          border-top: 0;\n          border-right: 0;\n          left: 17rem;\n          bottom: calc(-0.5rem - 0.042rem);\n        }\n\n        .main-title {\n          color: var(--color-primary-blue);\n          letter-spacing: 0;\n          line-height: 1.333rem;\n          font-size: 1.167rem;\n          font-weight: bold;\n          margin-bottom: 1.125rem;\n        }\n\n        .subtitle1 {\n          color: var(--color-primary-blue);\n          letter-spacing: 0;\n          line-height: 1.333rem;\n          font-size: 1rem;\n          font-weight: 600;\n        }\n\n        //.title-position {\n        //  font-size: 0.667rem;\n        //  line-height: 0.917rem;\n        //  color: #5B4C40;\n        //}\n\n        .page2 {\n\n          .main-title {\n            color: #404953;\n            font-size: 1rem;\n            line-height: 1.333rem;\n            font-weight: 600;\n          }\n\n          .bullets-box {\n            display: inline-block;\n          }\n\n          .info {\n            .dimension-number {\n              background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);\n              font-size: 0.833rem;\n              padding: 0.18rem 0.35rem;\n              border-radius: 50%;\n              color: var(--color-primary-blue);\n              height: fit-content;\n            }\n          }\n\n          .info {\n            display: flex;\n            margin-bottom: 0.3rem;\n\n            .text {\n              color: var(--color-primary-blue);\n              font-size: 1rem;\n              line-height: 1.333rem;\n              font-weight: bold;\n              margin-left: 0.5rem;\n              text-align: initial;\n            }\n          }\n\n          .description-text {\n            color: #404953;\n            font-weight: 300;\n            font-size: 1rem;\n            text-align: start;\n            margin-bottom: 0.667rem;\n            min-height: 1.833rem;\n          }\n\n          .rectangle {\n            min-height: 3.333rem;\n            border-radius: 0.292rem;\n            background-color: #F5DB6C;\n            box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);\n\n            .rectangle-text {\n              color: var(--color-primary-blue);\n              font-weight: 300;\n              font-size: 1rem;\n              top: 0;\n              right: 0;\n              width: 100%;\n              height: 100%;\n              display: flex;\n              justify-content: center;\n              align-items: center;\n              letter-spacing: 0;\n              text-align: center;\n              margin-top: -0.2rem;\n              padding: 0.4rem;\n            }\n          }\n        }\n\n        .page3 {\n          margin-left: 1rem;\n          margin-right: 1rem;\n\n          .main-title {\n            color: #404953;\n            font-size: 0.833rem;\n            line-height: 1.333rem;\n            font-weight: 600;\n          }\n\n          .info {\n            .dimension-number {\n              background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);\n              font-size: 0.833rem;\n              padding: 0.18rem 0.35rem;\n              border-radius: 50%;\n              color: var(--color-primary-blue);\n              position: absolute;\n              left: 1rem;\n            }\n          }\n\n          .info {\n            display: flex;\n            margin-bottom: 0.583rem;\n\n            .text {\n              color: var(--color-primary-blue);\n              font-size: 1rem;\n              line-height: 1.333rem;\n              font-weight: bold;\n            }\n          }\n\n          .propose-title {\n            color: #273B5A;\n            font-weight: 600;\n            font-size: 1rem;\n            text-align: start;\n            margin-bottom: 0.458rem;\n          }\n\n          .description-text {\n            color: #404953;\n            font-weight: 300;\n            font-size: 1rem;\n            text-align: start;\n            margin-bottom: 0.667rem;\n            min-height: 1.833rem;\n          }\n\n          .rectangle {\n            min-height: 3.333rem;\n            border-radius: 0.292rem;\n            background: var(--color-yellow-bookmark) linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.48) 100%);\n            box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.16);\n\n            .rectangle-text {\n              color: var(--color-primary-blue);\n              font-weight: 300;\n              font-size: 1rem;\n              top: 0;\n              right: 0;\n              width: 100%;\n              height: 100%;\n              display: flex;\n              justify-content: center;\n              align-items: center;\n              padding: 0.4rem;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .button-row {\n    width: 36rem;\n    margin: 0 auto;\n\n    .button-left-col {\n      z-index: 2;\n      text-align: start;\n\n      .previous-btn {\n        .button {\n          font-size: 0.875rem;\n          min-width: 8.417rem;\n          height: 2rem;\n          min-height: 2rem;\n          --min-height: 2rem;\n          font-weight: 600;\n        }\n      }\n    }\n\n    .button-right-col {\n      z-index: 2;\n      text-align: end;\n\n      .next-btn {\n        .button {\n          font-size: 0.875rem;\n          min-width: 8.417rem;\n          height: 2rem;\n          min-height: 2rem;\n          --min-height: 2rem;\n          font-weight: 600;\n        }\n      }\n    }\n  }\n\n  .presentation-col {\n    position: absolute;\n    bottom: 0;\n    display: flex;\n    justify-content: center;\n\n    .presentation {\n      height: 12.4rem;\n      width: 6rem;\n      display: flex;\n      justify-content: center;\n\n      .group {\n        position: absolute;\n        top: 57%;\n        z-index: 1;\n        width: 4rem;\n      }\n\n      .tribune {\n        position: absolute;\n        width: 6rem;\n        bottom: 0;\n      }\n\n      .avatar {\n        position: absolute;\n        width: 6rem;\n      }\n    }\n  }\n}\n\n.divScrollBar {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  max-height: 11.962rem;\n  overflow-y: auto;\n  width: 100%;\n  height: 100%;\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n  padding-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
